function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon/Icon';
import { CRUMBS_PROP_TYPE } from './constants';
import ChevronRightChunkySvg from '../iconography/icons/ChevronRightChunky';

var CrumbSeparator = function CrumbSeparator(_ref) {
  var isLastCrumb = _ref.isLastCrumb;
  var component = null;

  if (!isLastCrumb) {
    component = React.createElement("span", {
      className: "eds-l-mar-hor-1"
    }, React.createElement(Icon, {
      type: React.createElement(ChevronRightChunkySvg, null),
      size: "xsmall",
      color: "grey-400"
    }));
  }

  return component;
};

var DisabledCrumb = function DisabledCrumb(_ref2) {
  var label = _ref2.label;
  var component = null;

  if (label) {
    component = React.createElement("span", {
      "data-spec": "breadcrumbs-disabled",
      className: "eds-text-bm eds-text-color--grey-400"
    }, label);
  }

  return component;
};

var ActiveCrumb = function ActiveCrumb(_ref3) {
  var label = _ref3.label;
  var component = null;

  if (label) {
    component = React.createElement("span", {
      "data-spec": "breadcrumbs-active",
      className: "eds-text-bm eds-text-color--grey-900"
    }, label);
  }

  return component;
};

var LinkCrumb = function LinkCrumb(_ref4) {
  var label = _ref4.label,
      path = _ref4.path,
      onCrumbClick = _ref4.onCrumbClick;
  var component = null;

  if (label && path) {
    component = React.createElement("a", {
      className: "eds-breadcrumbs__item--link eds-text-bm eds-text-color--grey-600",
      href: path,
      "data-spec": "breadcrumbs-link",
      onClick: onCrumbClick.bind(null, path)
    }, label);
  }

  return component;
};

var CrumbItem = function CrumbItem(_ref5) {
  var isLinkCrumb = _ref5.isLinkCrumb,
      isLastCrumb = _ref5.isLastCrumb,
      isActive = _ref5.isActive,
      path = _ref5.path,
      label = _ref5.label,
      onCrumbClick = _ref5.onCrumbClick;
  var component = React.createElement(DisabledCrumb, {
    label: label
  });

  if (isActive) {
    component = React.createElement(ActiveCrumb, {
      label: label
    });
  } else if (isLinkCrumb) {
    component = React.createElement(LinkCrumb, {
      path: path,
      onCrumbClick: onCrumbClick,
      label: label
    });
  }

  return React.createElement("li", {
    key: path,
    className: "eds-breadcrumbs__item"
  }, component, React.createElement(CrumbSeparator, {
    isLastCrumb: isLastCrumb
  }));
};

var Breadcrumbs =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Breadcrumbs, _React$PureComponent);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumbs).apply(this, arguments));
  }

  _createClass(Breadcrumbs, [{
    key: "_handleClick",
    value: function _handleClick(path, e) {
      var onCrumbClick = this.props.onCrumbClick;

      if (onCrumbClick) {
        e.preventDefault();
        e.stopPropagation();
        onCrumbClick(path);
      }
    }
  }, {
    key: "_renderBreadcrumbs",
    value: function _renderBreadcrumbs() {
      var _this = this;

      var crumbs = this.props.crumbs; // change to true when the Active Crumb is created, so next crumbs are disabled

      var activeCrumbRendered = false;
      return crumbs.map(function (crumb, index) {
        var path = crumb.path,
            label = crumb.label,
            active = crumb.active;
        var isLastCrumb = index === crumbs.length - 1;
        var isLinkCrumb = !(activeCrumbRendered || active);

        if (active) {
          activeCrumbRendered = active;
        }

        return React.createElement(CrumbItem, {
          key: path,
          onCrumbClick: _this._handleClick.bind(_this),
          path: path,
          isActive: active,
          label: label,
          isLastCrumb: isLastCrumb,
          isLinkCrumb: isLinkCrumb
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var breadcrumbs = this._renderBreadcrumbs();

      return React.createElement("ul", {
        className: "eds-breadcrumbs"
      }, breadcrumbs);
    }
  }]);

  return Breadcrumbs;
}(React.PureComponent);

_defineProperty(Breadcrumbs, "propTypes", {
  /**
   * An array of breadcrumb objects containing url and path. Last item refers to the current directory.
   * ex. [{path: '/', label: 'Home'}, {path: '/tickets', label: 'My Tickets'}]
  */
  crumbs: CRUMBS_PROP_TYPE.isRequired,

  /**
   * A callback function that receives the path when a breadcrumb is clicked
   * When this prop is not passed, the component will redirect the user to the path by default
   * ex. (path) => {}
  */
  onCrumbClick: PropTypes.func
});

export { Breadcrumbs as default };